module.exports = __webpack_public_path__ + "static/media/loadingci.a76143fd.svg";